/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { AnyAction } from 'redux';

import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';

import IMunicipio from 'Infotrack@Modelos/administracion/municipio/entidades/municipio';
import IBodega from 'Infotrack@Modelos/smartStock/bodegas/entidades/bodega';
import ITiposBodegas from 'Infotrack@Modelos/smartStock/tiposBodegas/entidades/tiposBodegas';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import ITipoDocumento from 'Infotrack@Modelos/smartStock/tiposDocumentos/entidades/tipoDocumento';
import IDivisionesDocumentosDefecto from 'Infotrack@Modelos/smartStock/divisionesDocumentosDefecto/entidades/divisionesDocumentosDefecto';

import {
    IInputsBodega,
    IInputsBodegaPropiedades,
    IInputsBodegasDivisiones,
    IInputsBodegasPersonas,
    IInputsDivisionesDocumentosDefecto,
    IInputsMaximosMinimos,
} from './interfaces';
import { IInputsDivisionesPropiedas } from './interfaces/index';
import { IAgencia } from '@infotrack/presentacion-modulosbase';

export interface IEstadoGestionBodegas {
    bodega: IInputsBodega;
    bodegas: IBodega[];
    bodegaCreada: boolean;
    entidadBodegaDivision?: IInputsBodegasDivisiones;
    entidadBodegaPropiedades?: IInputsBodegaPropiedades;
    entidadDivisionesPropiedades?: IInputsDivisionesPropiedas;
    entidadBodegaPersona?: IInputsBodegasPersonas;
    entidadMaximosMinimos?: IInputsMaximosMinimos;
    entidadDivionesPorDefecto?: IInputsDivisionesDocumentosDefecto;
    estadoFormulario: boolean;
    estadoFormularioBodegaPropiedades: boolean;
    estadoFormularioDivisionPropiedades: boolean;
    estadoFormularioDivisionesBodega: boolean;
    estadoFormularioBodegaPersona: boolean;
    estadoFormularioMaximosMinimos: boolean;
    estadoFormularioDivionesPorDefecto: boolean;
    primeraCarga: boolean;
    propiedadesBodegas: IInputsBodegaPropiedades[];
    propiedadesDivisiones: IInputsDivisionesPropiedas[];
    recargarTabla: boolean;
    recargarTablaMaximosMinimos: boolean;
    recargarTablaBodegaDivisiones: boolean;
    recargarTablaBodegaPersona: boolean;
    recargarTablaDivionesPorDefecto: boolean;
    recargarEntidadesDivionesPorDefecto: boolean;
    tiposBodegas: ITiposBodegas[];
    tipoFormulario: TipoFormulario;
    tipoFormularioBodegaDivision: TipoFormulario;
    tipoFormularioBodegaPersona: TipoFormulario;
    tipoFormularioBodegaPropiedades: TipoFormulario;
    tipoFormularioDivisionPropiedades: TipoFormulario;
    tipoFormularioDivionesPorDefecto: TipoFormulario;
    tipoFormularioMaximosMinimos: TipoFormulario;
    municipios: IMunicipio[];
    listaDivisiones: IBodegaDivisiones[];
    listaTiposDocumentos: ITipoDocumento[];
    listaDivisionesDocumentosDefecto: IDivisionesDocumentosDefecto[];
    agencias:IAgencia[];
}

export const estadoInicial: IEstadoGestionBodegas = {
    bodega: {
        AgenciaId: '',
        Alto: '',
        Ancho: '',
        BodegaCodigo: '',
        BodegaDescripcion: '',
        BodegaId: undefined,
        BodegaPadre: null,
        Ciudad: null,
        EmpresaId: '',
        Estado: true,
        Largo: '',
        Latitud: '',
        Longitud: '',
        TipoBodegaId: '',
        Direccion: '',
        IdAgencia:'',
    },
    bodegas: [],
    bodegaCreada: false,
    entidadMaximosMinimos:undefined,
    entidadBodegaDivision: undefined,
    entidadBodegaPersona: undefined,
    entidadBodegaPropiedades: undefined,
    entidadDivisionesPropiedades: undefined,
    entidadDivionesPorDefecto: undefined,
    estadoFormularioMaximosMinimos: false,
    estadoFormulario: false,
    estadoFormularioBodegaPropiedades: false,
    estadoFormularioDivisionPropiedades: false,
    estadoFormularioDivisionesBodega: false,
    estadoFormularioBodegaPersona: false,
    estadoFormularioDivionesPorDefecto: false,
    primeraCarga: true,
    propiedadesBodegas: [],
    propiedadesDivisiones: [],
    recargarTabla: true,
    recargarTablaMaximosMinimos: false,
    recargarTablaBodegaDivisiones: false,
    recargarTablaBodegaPersona: false,
    recargarTablaDivionesPorDefecto: false,
    recargarEntidadesDivionesPorDefecto: false,
    tiposBodegas: [],
    tipoFormulario: TipoFormulario.Creacion,
    tipoFormularioMaximosMinimos: TipoFormulario.Creacion,
    tipoFormularioBodegaPersona: TipoFormulario.Creacion,
    tipoFormularioBodegaPropiedades: TipoFormulario.Creacion,
    tipoFormularioBodegaDivision: TipoFormulario.Creacion,
    tipoFormularioDivisionPropiedades: TipoFormulario.Creacion,
    tipoFormularioDivionesPorDefecto: TipoFormulario.Creacion,
    municipios: [],
    listaDivisiones: [],
    listaTiposDocumentos: [],
    listaDivisionesDocumentosDefecto: [],
    agencias:[]
};

export enum acciones {
    CAMBIAR_ESTADO_BODEGA_CREADA = 'CAMBIAR_ESTADO_BODEGA_CREADA',
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    CAMBIAR_ESTADO_FORMULARIO_BODEGA_PROPIEDADES = 'CAMBIAR_ESTADO_FORMULARIO_BODEGA_PROPIEDADES',
    CAMBIAR_ESTADO_FORMULARIO_MAXIMOS_MINIMOS = 'CAMBIAR_ESTADO_FORMULARIO_MAXIMOS_MINIMOS',
    CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_BODEGA = 'CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_BODEGA',
    CAMBIAR_ESTADO_FORMULARIO_DIVISION_PROPIEDADES = 'CAMBIAR_ESTADO_FORMULARIO_DIVISION_PROPIEDADES',
    CAMBIAR_ESTADO_FORMULARIO_BODEGA_PERSONA = 'CAMBIAR_ESTADO_FORMULARIO_BODEGA_PERSONA',
    CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_POR_DEFECTO = 'CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_POR_DEFECTO',
    CAMBIAR_ESTADO_PRIMERA_CARGA = 'CAMBIAR_ESTADO_PRIMERA_CARGA',
    ESTABLECER_BODEGA_DIVISION = 'ESTABLECER_BODEGA_DIVISION',
    ESTABLECER_MAXIMOS_MINIMOS = 'ESTABLECER_MAXIMOS_MINIMOS',
    ESTABLECER_BODEGAS = 'ESTABLECER_BODEGAS',
    ESTABLECER_BODEGA_PERSONA = 'ESTABLECER_BODEGA_PERSONA',
    ESTABLECER_DIVISIONES_PROPIEDADES = 'ESTABLECER_DIVISIONES_PROPIEDADES',
    ESTABLECER_BODEGA_PROPIEDADES = 'ESTABLECER_BODEGA_PROPIEDADES',
    ESTABLECER_DIVISIONES_POR_DEFECTO = 'ESTABLECER_DIVISIONES_POR_DEFECTO',
    ESTABLECER_TIPOS_BODEGAS = 'ESTABLECER_TIPOS_BODEGAS',
    ESTABLECER_MUNICIPIOS = 'ESTABLECER_MUNICIPIOS',
    MODIFICAR_BODEGA = 'MODIFICAR_BODEGA',
    MODIFICAR_PROPIEDADES_BODEGA = 'MODIFICAR_PROPIEDADES_BODEGA',
    MODIFICAR_PROPIEDADES_DIVISIONES = 'MODIFICAR_PROPIEDADES_DIVISIONES',
    MODIFICAR_TIPO_FORMULARIO = 'MODIFICAR_TIPO_FORMULARIO',
    MODIFICAR_TIPO_FORMULARIO_MAXIMOS_MINIMOS = 'MODIFICAR_TIPO_FORMULARIO_MAXIMOS_MINIMOS',
    MODIFICAR_TIPO_FORMULARIO_BODEGA_DIVISION = 'MODIFICAR_TIPO_FORMULARIO_BODEGA_DIVISION',
    MODIFICAR_TIPO_FORMULARIO_BODEGA_PERSONA = 'MODIFICAR_TIPO_FORMULARIO_BODEGA_PERSONA',
    MODIFICAR_TIPO_FORMULARIO_BODEGA_PROPIEDADES = 'MODIFICAR_TIPO_FORMULARIO_BODEGA_PROPIEDADES',
    MODIFICAR_TIPO_FORMULARIO_DIVISION_PROPIEDADES = 'MODIFICAR_TIPO_FORMULARIO_DIVISION_PROPIEDADES',
    MODIFICAR_TIPO_FORMULARIO_DIVISIONES_POR_DEFECTO = 'MODIFICAR_TIPO_FORMULARIO_DIVISIONES_POR_DEFECTO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
    RECARGAR_TABLA_MAXIMOS_MINIMOS = 'RECARGAR_TABLA_MAXIMOS_MINIMOS',
    RECARGAR_TABLA_BODEGA_DIVISIONES = 'RECARGAR_TABLA_BODEGA_DIVISIONES',
    RECARGAR_TABLA_BODEGA_PERSONA = 'RECARGAR_TABLA_BODEGA_PERSONA',
    RECARGAR_TABLA_DIVISIONES_POR_DEFECTO = 'RECARGAR_TABLA_DIVISIONES_POR_DEFECTO',
    ESTABLECER_LISTA_DIVISIONES = 'ESTABLECER_LISTA_DIVISIONES',
    ESTABLECER_LISTA_TIPOS_DOCUMENTOS = 'ESTABLECER_LISTA_TIPOS_DOCUMENTOS',
    ESTABLECER_LISTA_DIVISIONES_POR_DEFECTO = 'ESTABLECER_LISTA_DIVISIONES_POR_DEFECTO',
    RECARGAR_ENTIDADES_DIVISIONES_POR_DEFECTO = 'RECARGAR_ENTIDADES_DIVISIONES_POR_DEFECTO',
    ESTABLECER_AGENCIAS = 'ESTABLECER_AGENCIAS',
}

export const reductor = (estado: IEstadoGestionBodegas = estadoInicial, { type, payload }: AnyAction) => {
    switch (type) {
        case acciones.CAMBIAR_ESTADO_BODEGA_CREADA: {
            return { ...estado, bodegaCreada: !estado.bodegaCreada };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_BODEGA_PROPIEDADES: {
            return { ...estado, estadoFormularioBodegaPropiedades: !estado.estadoFormularioBodegaPropiedades };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO: {
            if (estado.estadoFormulario) return { ...estadoInicial, recargarTabla: true };
            else
                return {
                    ...estado,
                    estadoFormulario: !estado.estadoFormulario,
                    bodega: payload
                        ? { ...payload, BodegaPadre: estado.bodega.BodegaPadre, Ciudad: estado.bodega.Ciudad }
                        : estado.bodega,
                };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_MAXIMOS_MINIMOS: {
            return { ...estado, estadoFormularioMaximosMinimos: !estado.estadoFormularioMaximosMinimos };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_BODEGA: {
            return { ...estado, estadoFormularioDivisionesBodega: !estado.estadoFormularioDivisionesBodega };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_DIVISION_PROPIEDADES: {
            return { ...estado, estadoFormularioDivisionPropiedades: !estado.estadoFormularioDivisionPropiedades };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_BODEGA_PERSONA: {
            return { ...estado, estadoFormularioBodegaPersona: !estado.estadoFormularioBodegaPersona };
        }

        case acciones.CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_POR_DEFECTO: {
            return { ...estado, estadoFormularioDivionesPorDefecto: !estado.estadoFormularioDivionesPorDefecto };
        }

        case acciones.CAMBIAR_ESTADO_PRIMERA_CARGA: {
            return { ...estado, primeraCarga: !estado.primeraCarga };
        }

        case acciones.ESTABLECER_BODEGA_DIVISION: {
            return { ...estado, entidadBodegaDivision: payload };
        }

        case acciones.ESTABLECER_BODEGAS: {
            return { ...estado, bodegas: payload };
        }

        case acciones.ESTABLECER_BODEGA_PERSONA: {
            return { ...estado, entidadBodegaPersona: payload };
        }

        case acciones.ESTABLECER_MAXIMOS_MINIMOS: {
            return { ...estado, entidadMaximosMinimos: payload };
        }

        case acciones.ESTABLECER_BODEGA_PROPIEDADES: {
            return { ...estado, entidadBodegaPropiedades: payload };
        }

        case acciones.ESTABLECER_DIVISIONES_PROPIEDADES: {
            return { ...estado, entidadDivisionesPropiedades: payload };
        }

        case acciones.ESTABLECER_DIVISIONES_POR_DEFECTO: {
            return { ...estado, entidadDivionesPorDefecto: payload };
        }

        case acciones.ESTABLECER_TIPOS_BODEGAS: {
            return { ...estado, tiposBodegas: payload };
        }

        case acciones.ESTABLECER_MUNICIPIOS: {
            return { ...estado, municipios: payload };
        }

        case acciones.MODIFICAR_BODEGA: {
            return { ...estado, bodega: payload };
        }

        case acciones.MODIFICAR_PROPIEDADES_BODEGA: {
            return { ...estado, propiedadesBodegas: payload };
        }

        case acciones.MODIFICAR_PROPIEDADES_DIVISIONES: {
            return { ...estado, propiedadesDivisiones: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO: {
            return { ...estado, tipoFormulario: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO_MAXIMOS_MINIMOS: {
            return { ...estado, tipoFormularioMaximosMinimos: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO_BODEGA_PERSONA: {
            return { ...estado, tipoFormularioBodegaPersona: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO_BODEGA_PROPIEDADES: {
            return { ...estado, tipoFormularioBodegaPropiedades: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO_DIVISION_PROPIEDADES: {
            return { ...estado, tipoFormularioDivisionPropiedades: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO_BODEGA_DIVISION: {
            return { ...estado, tipoFormularioBodegaDivision: payload };
        }

        case acciones.MODIFICAR_TIPO_FORMULARIO_DIVISIONES_POR_DEFECTO: {
            return { ...estado, tipoFormularioDivionesPorDefecto: payload };
        }

        case acciones.RECARGAR_TABLA: {
            return { ...estado, recargarTabla: !estado.recargarTabla };
        }

        case acciones.RECARGAR_TABLA_MAXIMOS_MINIMOS: {
            return { ...estado, recargarTablaMaximosMinimos: !estado.recargarTablaMaximosMinimos };
        }

        case acciones.RECARGAR_TABLA_BODEGA_PERSONA: {
            return { ...estado, recargarTablaBodegaPersona: !estado.recargarTablaBodegaPersona };
        }

        case acciones.RECARGAR_TABLA_BODEGA_DIVISIONES: {
            return { ...estado, recargarTablaBodegaDivisiones: !estado.recargarTablaBodegaDivisiones };
        }

        case acciones.RECARGAR_TABLA_DIVISIONES_POR_DEFECTO: {
            return { ...estado, recargarTablaDivionesPorDefecto: !estado.recargarTablaDivionesPorDefecto };
        }

        case acciones.ESTABLECER_LISTA_DIVISIONES: {
            return { ...estado, listaDivisiones: payload };
        }

        case acciones.ESTABLECER_LISTA_TIPOS_DOCUMENTOS: {
            return { ...estado, listaTiposDocumentos: payload };
        }

        case acciones.ESTABLECER_LISTA_DIVISIONES_POR_DEFECTO: {
            return { ...estado, listaDivisionesDocumentosDefecto: payload };
        }

        case acciones.RECARGAR_ENTIDADES_DIVISIONES_POR_DEFECTO: {
            return { ...estado, recargarEntidadesDivionesPorDefecto: !estado.recargarEntidadesDivionesPorDefecto };
        }

        case acciones.ESTABLECER_AGENCIAS: {
            return { ...estado, agencias : payload };
        }

        default:
            return estado;
    }
};
